import React from 'react';
import { Utilities } from './utilities.js';
import { PersonContact } from './personcontact.js';
import { Website } from './website.js';

export class Modal extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        if(Utilities.isEmpty(this.props.contactCard)){
            return <p></p>;
        }
        return <div className="modal fade">
            <div className="modal-dialog">
                <div className="modal-content">
                    <ModalHeader title={this.props.contactCard.Name} />
                    <ModalBody body= {this.props.contactCard} translations = {this.props.translations} isPerson = {this.props.isPerson} />
                    <ModalFooter translations = {this.props.translations} /> 
                    </div>
                </div>
            </div>;
        
    }
}

export class ModalHeader extends React.Component{
    constructor(){
        super();
    }
    render(){
        return <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    }
}

export class ModalBody extends React.Component{
    constructor(){
        super();
    }
    render(){
        const isPerson = this.props.isPerson;
        if(isPerson) {
            return (
                <div className="modal-body">
                    <PersonContact body = {this.props.body} isPerson={isPerson}/>            
                </div>
            );
        }
        else {
            return (
                <div className="modal-body">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div className="dealer">
                        <div className="dealer-info">
                            {this.props.body.Image !== null ?
                                <div className="image">
                                    <img src={this.props.body.Image} className="rounded lazy" alt="" />
                                </div>
                                : ''
                            }
                            <div className="text">
                                <h3>{this.props.body.Name}</h3>
                                <p className="info">
                                    {this.props.body.Title}
                                </p>
                                {this.renderAddress(this.props.body)}
                
                                <p className="adress">
                                    {this.props.body.OtherInformation}
                                </p>
                                {this.props.body.Phone !== null ? 
                                    <p className="contact-link" itemProp="telephone">
                                        <a href={"tel:" + this.props.body.Phone}  className="phone"><span className="icon-phone"> </span>  
                                        {this.props.body.Phone}
                                        </a>
                                    </p> : ''
                                }
    
                                {this.props.body.MobilePhone !== null ? 
                                    <p className="contact-link" itemProp="telephone contact-link">
                                        <a href={"tel:"  + this.props.body.MobilePhone} className="phone">
                                            <span className="icon-mobile"> </span>
                                        {this.props.body.MobilePhone}
                                        </a>
                                    </p> : ''
                                }
            
                                {this.props.body.Fax !== null ? 
                                    <p className="contact-link" itemProp="fax contact-link">
                                        <a href={"tel:"  + this.props.body.Fax} className="phone">
                                            <span className="icon-printer"> </span>
                                        {this.props.body.Fax}
                                        </a>
                                    </p> : ''
                                }
            
                                <p className="contact-link" itemProp="email">
                                    <a href={"mailto:" + this.props.body.Email} className="email">{ this.props.body.Email }</a>
                                </p>
                                <Website className="contact-link" webaddress={this.props.body.Website} />
                            </div>
                        </div>
                        {this.renderConnectedContacts(this.props.body.ConnectedContacts)}
                    </div>
                </div>
            )
        }        
    }

    renderAddress(dealer){
        if(dealer.IsUnitedKingdomDealer){
            return <div className="address">
                        <p>{dealer.Street}</p>
                        <p>{dealer.Town} </p>
                        <p>{dealer.City} </p>
                        <p>{dealer.County} </p>
                        <p>{dealer.ZipCode} </p>
                        <p>{dealer.Country} </p>
                    </div>
        }
        else{
            return <div className="address">
                        <p>{dealer.Street}</p>
                        <p>{dealer.ZipCode} {dealer.City} </p>
                        <p>{dealer.Country} </p>
                    </div>
        }
    }

    renderConnectedContacts(){ 
        if(this.props.body.ConnectedContacts.length !== 0){
            if(this.props.body.ConnectedContacts.length === 1){
                return <div className="connected-contacts contact-center">
                        <h3 className="margin-bottom-15" >{this.props.translations.connectedContacts}</h3>
                {this.props.body.ConnectedContacts.map((contact) => {
                    return this.renderContact(contact)
                })}
                </div>
            } else {
                return <div className="connected-contacts">
                        <h3 className="margin-bottom-15" >{this.props.translations.connectedContacts}</h3>
                    <div className="contacts">
                        {this.props.body.ConnectedContacts.map((contact) => {
                            return this.renderContact(contact)
                        })}
                    </div>
                </div>
            }
        }
    }

    renderContact(contact){
        return <div key={contact.Id} className="connected-contact">
            {contact.Image !== null ?
            <div className="image">
                <img src={contact.Image} className="rounded lazy" alt="" />
            </div>
            : ''}
            <div className="text">
                {contact.Name !== null ? <h4>{contact.Name}</h4> : ''}
                {contact.Title !== null ? <p>{contact.Title}</p> : '' }
                {contact.Area !== null? <p>{contact.Area}</p> : '' }
                {contact.MobilePhone !== null ? <p><a href={"tel:" + contact.MobilePhone}><span className="icon-mobile"> </span>{contact.MobilePhone}</a></p> : ''}
                {contact.Phone !== null ? <p><a href={"tel:" + contact.Phone}><span className="icon-phone"> </span>{contact.Phone}</a></p> : '' }
                {contact.Email !== null ? <p><a href={"mailto:" + contact.Email}>{contact.Email}</a></p> : ''}
            </div>
        </div>
    }
}

export class ModalFooter extends React.Component{
    constructor(){
        super();
    }
    render(){
        return <div className="modal-footer">
            <button type="button" className="btn btn-primary" data-dismiss="modal">{this.props.translations.close}</button>
        </div>;
    }
}

function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}

